import { useTranslation } from 'react-i18next';
import { useGlobal } from 'context/GlobalContext';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

interface TitleCounterProps {
    title?: string | null;
    count?: string | number | null;
    color?: string;
    noShowCount?: boolean;
}

const TitleCounter = ({
    title = null,
    count = null,
    color = 'primary',
    noShowCount = false,
}: TitleCounterProps) => {
    const { t } = useTranslation();
    const { g } = useGlobal();
    const location = useLocation();
    const [showCount, setShowCount] = useState<string | number | null>(null);

    useEffect(() => {
        if (count === null) {
            setShowCount(g?.paginator?.[location.pathname]?.countRows);
        } else setShowCount(count);
    }, [count, g?.paginator?.[location.pathname]?.countRows, location.pathname]);

    return (
        <div className={`fs-12 me-2 fw-medium text-${color} d-inline-block`}>
            <span>
                {title ? title : t('count')}
                {noShowCount ? '' : ':'}
            </span>{' '}
            <span className="fw-bold">{noShowCount ? null : showCount}</span>
        </div>
    );
};

export default TitleCounter;
